<template>
    <div class="page bg-gray pb-fixed-btn">
        <backTitleBar></backTitleBar>
        <div class="content">
            <div class="card">
                <div class="pd-020">
                    <div class="filed-input-box bd-bot">
                        <div class="required fs-32 color-333">店铺logo（400*400）</div>
                        <div class="fs-28 color-999 pl-15">(支持jpg、bmp格式图片，大小不要超过1M/张)</div>
                        <div class="flex" style="flex-wrap: wrap;">
                            <div class="pic-box" v-show="formItem.mainPicView">
                                <img :src="formItem.mainPicView" alt="" >
                                <div class="clean" @click="delImg('mainPicView')"></div>
                            </div>
                            <van-uploader v-model="imgList" preview-size="1.45rem" :preview-image="false" :after-read="afterReadMain" v-show="!formItem.mainPicView"/>
                        </div>
                    </div>
                    <div class="filed-input-box bd-bot">
                        <div class="required fs-32 color-333">店铺图片（750*300）</div>
                        <div class="fs-28 color-999 pl-15">(支持jpg、bmp格式图片，大小不要超过1M/张)</div>
                        <div class="flex" style="flex-wrap: wrap;">
                            <div class="pic-box" v-show="formItem.indexPicView">
                                <img :src="formItem.indexPicView" alt="" >
                                <div class="clean" @click="delImg('indexPicView')"></div>
                            </div>
                            <van-uploader v-model="imgList" preview-size="1.45rem" :preview-image="false" :after-read="afterReadIndex" v-show="!formItem.indexPicView"/>
                        </div>
                    </div>
                    <div class="input-field">
                        <div class="fs-32 color-333 left">店铺介绍</div>
                        <input type="text" class="input" placeholder="请输入店铺介绍" v-model="formItem.shopDesc">
                    </div>
                </div>
            </div>
        </div>
        <div class="fixed-bot">
            <div class="btn click" @click="submitForm()">保存</div>
        </div>
    </div>
</template>

<script>
    import backTitleBar from "@/components/titleBar/backTitleBar"
    import {qryShopDetail,saveMallShopInfo} from "@/api/shop"
    import uploadImg from "@/api/uploadImg"
    import inputFix from "@/mixins/inputBugFix"
    export default {
        name: "shopInfo",
        components:{backTitleBar},
        mixins:[inputFix],
        data(){
            return{
                imgList:[],
                formItem:{},
                shopId:this.$store.state.user.shopId
            }
        },
        created(){
            this.getDetail();
        },
        methods:{
            //删除图片
            delImg(field){
                this.$set(this.formItem,field,'')
            },
            //选中图片后上传服务器
            async afterReadMain(file){
                let result = await uploadImg(file.file,'shop');
                this.setField(result,'mainPic','mainPicView')
            },
            async afterReadIndex(file){
                let result = await uploadImg(file.file,'shop');
                this.setField(result,'indexPic','indexPicView')
            },
            setField(result,picField,picViewField){
                this.$set(this.formItem,picField,result.fileUrl)
                this.$set(this.formItem,picViewField,result.fileUrlView)
            },

            beforeRead(file){
                console.log('开始读取文件：',file);
                return true
            },

            //获取商家详情
            getDetail(){
                qryShopDetail(this.shopId).then(res=>{
                    this.formItem = res.data;
                })
            },

            submitForm(){
                let form = this.formItem
                if(!form.indexPicView){
                    this.$toast("请上传店铺图片");
                    return
                }
                if(!form.mainPicView){
                    this.$toast("请上传店铺logo图");
                    return
                }
                let params = {
                    indexPic: form.indexPic,
                    mainPic: form.mainPic,
                    shopName: form.shopName,
                    shopId:form.shopId
                }
                if(form.shopDesc){
                    params.shopDesc = form.shopDesc
                }
                saveMallShopInfo(params).then(res=>{
                    if(res.code == 0){
                        this.$toast("保存成功");
                        this.$router.back();
                    }

                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .content{
        padding: .2rem .24rem;
    }
</style>



// WEBPACK FOOTER //
// shopInfo.vue?5019deb7